import React from 'react';
import { ArrowUpDown, ChevronUp, ChevronDown } from 'lucide-react';

export function SortableHeader({ column, label, sortColumn, sortDir, onSort, className = '' }) {
  const isActive = sortColumn === column;
  return (
    <th
      className={`text-left p-4 cursor-pointer select-none hover:bg-slate-100 transition-colors ${className}`}
      onClick={() => onSort(column)}
    >
      <span className='flex items-center text-sm font-bold uppercase tracking-wider text-slate-700'>
        {label}
        {isActive ? (
          sortDir === 'asc'
            ? <ChevronUp className='w-3.5 h-3.5 ml-1 text-[#1A3668]' />
            : <ChevronDown className='w-3.5 h-3.5 ml-1 text-[#1A3668]' />
        ) : (
          <ArrowUpDown className='w-3.5 h-3.5 ml-1 text-slate-400' />
        )}
      </span>
    </th>
  );
}
